<template>
  <td>
    <div class="input-group-sm">
      <input
        type="text"
        class="form-control shadow-none"
        v-model.trim="v$.option.name.$model"
        style="
          height: 25px;
          font-size: 14px;
        "
        :placeholder="$t('Enter option name') + '...'"
      >
      <div v-for="error of v$.option.name.$errors"
        class="d-block invalid-feedback"
        :key="error.$uid"
      >
        {{ error.$message }}
      </div>
    </div>
  </td>
  <!-- ชื่ออังกฤษ optional — ไม่กรอกก็ได้ ระบบ fallback ไปใช้ชื่อไทย -->
  <td>
    <div class="input-group-sm">
      <input
        type="text"
        class="form-control shadow-none"
        v-model.trim="v$.option.name_en.$model"
        style="
          height: 25px;
          font-size: 14px;
        "
        :placeholder="$t('Optional') + '...'"
      >
      <div v-for="error of v$.option.name_en.$errors"
        class="d-block invalid-feedback"
        :key="error.$uid"
      >
        {{ error.$message }}
      </div>
    </div>
  </td>
  <td>
    <div class="input-group-sm">
      <input
        type="text"
        class="form-control shadow-none"
        v-model.trim="v$.option.code.$model"
        style="
          height: 25px;
          font-size: 14px;
        "
        :placeholder="$t('Enter option code') + '...'"
      >
      <div v-for="error of v$.option.code.$errors"
        class="d-block invalid-feedback"
        :key="error.$uid"
      >
        {{ error.$message }}
      </div>
    </div>
  </td>
  <td
    class="text-end"
  >
    <i
      @click="$parent.deleteItem(index)"
      class="fa-solid fa-trash text-danger"
      style="cursor: pointer;"
    />
  </td>
</template>

<script lang="js">
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-option";

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.option)
  },
  props: {
    option: {
      type: Object,
      default: []
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    let vm = this;
    return {
    }
  },
  components: {
  },
  methods: {
  },
  async mounted() {},
  computed: {
  },
  watch: {
  }
}
</script>
